const areSameFlatArray = (array1, array2) => {
  const str1 = JSON.stringify(array1.sort());
  const str2 = JSON.stringify(array2.sort());

  return str1 === str2;
};

export const isSame = (array1, array2) =>
  array1.length == array2.length && array1.every((element, index) => element === array2[index]);

export { areSameFlatArray };

export function uniq(arr) {
  return arr.filter((el, index, self) => self.indexOf(el) === index);
}

export function findCommonElements([...arrays]) {
  // Vérifier s'il y a au moins deux tableaux
  if (arrays.length < 2) {
    return arrays[0];
  }

  // Fonction pour trouver les éléments communs entre deux tableaux
  const findCommonBetweenTwo = (arr1, arr2) => arr1.filter((element) => arr2.includes(element));

  // Utiliser reduce pour trouver les éléments communs entre tous les tableaux
  const commonElements = arrays.reduce((acc, currentArray) => {
    return findCommonBetweenTwo(acc, currentArray);
  });

  return commonElements;
}
